import React from 'react';
import Table, { TableColumn } from './Table';
import { ServiceStatus, Status } from '../types/dashboard';

const serviceStatusColumns: TableColumn<ServiceStatus>[] = [
  { key: 'name', label: 'Service', align: 'left' },
  {
    key: 'status',
    label: 'Status',
    align: 'left',
    render: (value: unknown) => {
      const status = value as Status;
      return (
        <>
          <span
            className={`inline-block w-3 h-3 rounded-full mr-2 ${
              status === 'healthy' ? 'bg-green-500' : status === 'unhealthy' ? 'bg-red-500' : 'bg-gray-400'
            }`}
          ></span>
          <span
            className={`font-bold ${status === 'healthy' ? 'text-green-600' : status === 'unhealthy' ? 'text-red-600' : 'text-gray-500'}`}
          >
            {status}
          </span>
        </>
      );
    },
  },
];

interface ServiceStatusTableProps {
  data: ServiceStatus[];
}

const ServiceStatusTable: React.FC<ServiceStatusTableProps> = ({ data }) => (
  <div className="companies-list-container">
    <div className="overflow-x-auto">
      <Table<ServiceStatus> columns={serviceStatusColumns} data={data} />
    </div>
  </div>
);

export default ServiceStatusTable;
